/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationRequest {
    getFixupPrototypeFunction() { return UserDelegationRequest.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationRequest>): UserDelegationRequest {
        let obj = Object.assign(new UserDelegationRequest(), model);
        UserDelegationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationRequest>): UserDelegationRequest {
        if (!model) return null;
        return UserDelegationRequest.newInstance(<UserDelegationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationRequest) {
        if (!obj) return;

        models.UserDelegationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationRequest): boolean {
        Object.setPrototypeOf(obj, UserDelegationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    source_user_groups: Array<string>;

    source_roles: Array<string>;

    source_users: Array<string>;

    /**
     * User delegation target account master id
     */
    target_master_account_id: string;

    target_roles: Array<string>;

    target_user_groups: Array<string>;

}
